export default {
    holidays: [
        [1, 1], // New Year's Day
        [25, 12], // Christmas Day
        [26, 12], // Boxing Day
    ],
};
